export default __webpack_public_path__ + "asset/img/taoke-flag-3~21f07a36.png";